 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1501PHANTOMDREAMTOOCHAOTIC from '@/components/0_chapter1501phantomdreamtoochaotic'
 import A_CHAPTER1502DANGER from '@/components/1_chapter1502danger'
 import A_CHAPTER1503MAPLEWINGHEAVENLYVALLEY from '@/components/2_chapter1503maplewingheavenlyvalley'
 import A_CHAPTER1504WEEPINGABYSS from '@/components/3_chapter1504weepingabyss'
 import A_CHAPTER1505ROYALPHOENIXCANG from '@/components/4_chapter1505royalphoenixcang'
 import A_CHAPTER1506GREATWARWARMTH from '@/components/5_chapter1506greatwarwarmth'
 import A_CHAPTER1507HEAVENANDEARTHSEALGIANTDEMONSEAL from '@/components/6_chapter1507heavenandearthsealgiantdemonseal'
 import A_CHAPTER1508VULNERABLETOASINGLEBLOW from '@/components/7_chapter1508vulnerabletoasingleblow'
 import A_CHAPTER1509HOLINESSANDENCHANTMENT from '@/components/8_chapter1509holinessandenchantment'
 import A_CHAPTER1510THEWHITEEMPERORSEYES from '@/components/9_chapter1510thewhiteemperorseyes'
 import A0_CHAPTER1511GUILT from '@/components/10_chapter1511guilt'
 import A1_CHAPTER1512REMNANTBUTTERFLY from '@/components/11_chapter1512remnantbutterfly'
 import A2_CHAPTER1513WHATNEEDSTOBETAKENBACK from '@/components/12_chapter1513whatneedstobetakenback'
 import A3_CHAPTER1514THEFEARTHATCAMEFROMTHOSEEYES from '@/components/13_chapter1514thefearthatcamefromthoseeyes'
 import A4_CHAPTER1515STILBENE from '@/components/14_chapter1515stilbene'
 import A5_CHAPTER1516EYEOFGOD from '@/components/15_chapter1516eyeofgod'
 import A6_CHAPTER1517CREDITOR from '@/components/16_chapter1517creditor'
 import A7_CHAPTER1518RETURNTOEASTERNREGION from '@/components/17_chapter1518returntoeasternregion'
 import A8_CHAPTER1519WHATISAWISH from '@/components/18_chapter1519whatisawish'
 import A9_CHAPTER1520RETURNTOMOUNTKUNLIU from '@/components/19_chapter1520returntomountkunliu'
 import A0_CHAPTER1521HESBACK from '@/components/20_chapter1521hesback'
 import A1_CHAPTER1522THEYEFAMILYSDIFFICULTIES from '@/components/21_chapter1522theyefamilysdifficulties'
 import A2_CHAPTER1523TENYEARS from '@/components/22_chapter1523tenyears'
 import A3_CHAPTER1524ARRIVINGATKUNCITY from '@/components/23_chapter1524arrivingatkuncity'
 import A4_CHAPTER1525BEINGTARGETED from '@/components/24_chapter1525beingtargeted'
 import A5_CHAPTER1526ATTRACTINGDEMONICBEASTS from '@/components/25_chapter1526attractingdemonicbeasts'
 import A6_CHAPTER1527PAWNSHOPEIGHT from '@/components/26_chapter1527pawnshopeight'
 import A7_CHAPTER1528MANCITY from '@/components/27_chapter1528mancity'
 import A8_CHAPTER1529HOMEWHITEEMPERORCITYOFCLOUDREALM from '@/components/28_chapter1529homewhiteemperorcityofcloudrealm'
 import A9_CHAPTER1530DRAGONBLOODSAINTS from '@/components/29_chapter1530dragonbloodsaints'
 import A0_CHAPTER1531LONGQINGYANG from '@/components/30_chapter1531longqingyang'
 import A1_CHAPTER1532IMNOTGOINGTOLETYOUGO from '@/components/31_chapter1532imnotgoingtoletyougo'
 import A2_CHAPTER1533DRAGONBLOODEDSACREDFAMILY from '@/components/32_chapter1533dragonbloodedsacredfamily'
 import A3_CHAPTER1534SAINTBLOODDRAGON from '@/components/33_chapter1534saintblooddragon'
 import A4_CHAPTER1535ASINGLESPEARSTRIKEHADKILLEDTHEGREATSAGEKINGOFTHEDRAGONBLOOD from '@/components/34_chapter1535asinglespearstrikehadkilledthegreatsagekingofthedragonblood'
 import A5_CHAPTER1536ARMORBREAKING from '@/components/35_chapter1536armorbreaking'
 import A6_CHAPTER1537SLAYINGFORMLESS from '@/components/36_chapter1537slayingformless'
 import A7_CHAPTER1538DEMONICEYEHOLYRACEUNHARMED from '@/components/37_chapter1538demoniceyeholyraceunharmed'
 import A8_CHAPTER1539THEHEROICSOULSHALLNOTPERISHBUTSHALLREMAININTHEWORLD from '@/components/38_chapter1539theheroicsoulshallnotperishbutshallremainintheworld'
 import A9_CHAPTER1540YOUVEALREADYSEENIT from '@/components/39_chapter1540youvealreadyseenit'
 import A0_CHAPTER1541HEARTBEAST from '@/components/40_chapter1541heartbeast'
 import A1_CHAPTER1542HESGOINGTOCOMEOUT from '@/components/41_chapter1542hesgoingtocomeout'
 import A2_CHAPTER1543DESTINY from '@/components/42_chapter1543destiny'
 import A3_CHAPTER1544DEMONEYEHOLYRACECOME from '@/components/43_chapter1544demoneyeholyracecome'
 import A4_CHAPTER1545ALLOFYOUCOMEATMETOGETHER from '@/components/44_chapter1545allofyoucomeatmetogether'
 import A5_CHAPTER1546FLAWLESS from '@/components/45_chapter1546flawless'
 import A6_CHAPTER1547DESTRUCTIONEXTREMELYRETROGRADESPEAR from '@/components/46_chapter1547destructionextremelyretrogradespear'
 import A7_CHAPTER1548AVAILABLEATANYTIME from '@/components/47_chapter1548availableatanytime'
 import A8_CHAPTER1549RAGEREALMVIOLETIMPERIALCITY from '@/components/48_chapter1549ragerealmvioletimperialcity'
 import A9_CHAPTER1550HUI from '@/components/49_chapter1550hui'
 import A0_CHAPTER1551INVOLVINGTHEWORLD from '@/components/50_chapter1551involvingtheworld'
 import A1_CHAPTER1552NATURALDESTINY from '@/components/51_chapter1552naturaldestiny'
 import A2_CHAPTER1553DAUGHTEROFTHEWHITEEMPEROR from '@/components/52_chapter1553daughterofthewhiteemperor'
 import A3_CHAPTER1554SHIVERING from '@/components/53_chapter1554shivering'
 import A4_CHAPTER1555CONTRACT from '@/components/54_chapter1555contract'
 import A5_CHAPTER1556IMISSYOUSOMUCH from '@/components/55_chapter1556imissyousomuch'
 import A6_CHAPTER1557WHENFLOWERSBLOOMAGAINPEOPLEWILLMEETAGAIN from '@/components/56_chapter1557whenflowersbloomagainpeoplewillmeetagain'
 import A7_CHAPTER1558THEREISADIVINEWILLINTHEWORLD from '@/components/57_chapter1558thereisadivinewillintheworld'
 import A8_CHAPTER1559APERSONWHOISUNABLETOSEETHROUGH from '@/components/58_chapter1559apersonwhoisunabletoseethrough'
 import A9_CHAPTER1560COMPRESS from '@/components/59_chapter1560compress'
 import A0_CHAPTER1561PLACEOFINSCRIPTIONS from '@/components/60_chapter1561placeofinscriptions'
 import A1_CHAPTER1562TIANJICITY from '@/components/61_chapter1562tianjicity'
 import A2_CHAPTER1563WANXIANGFORMATION from '@/components/62_chapter1563wanxiangformation'
 import A3_CHAPTER1564CONSEQUENCES from '@/components/63_chapter1564consequences'
 import A4_CHAPTER1565BREAKTHROUGHTHEFORMATION from '@/components/64_chapter1565breakthroughtheformation'
 import A5_CHAPTER1566NOTSOMETHING from '@/components/65_chapter1566notsomething'
 import A6_CHAPTER1567HAVEBEENCHEATED from '@/components/66_chapter1567havebeencheated'
 import A7_CHAPTER1568EVILKILLINGSWORDFORMATION from '@/components/67_chapter1568evilkillingswordformation'
 import A8_CHAPTER1569ONEWAVETHREETWISTSANDTURNS from '@/components/68_chapter1569onewavethreetwistsandturns'
 import A9_CHAPTER1570MASTEROFTHETEMPLEOFHEAVENLYSECRETS from '@/components/69_chapter1570masterofthetempleofheavenlysecrets'
 import A0_CHAPTER157110000YEARIMMORTALTALISMANSPIRITTREE from '@/components/70_chapter157110000yearimmortaltalismanspirittree'
 import A1_CHAPTER1572MISTYSKY from '@/components/71_chapter1572mistysky'
 import A2_CHAPTER1573REDMOONDESCENDS from '@/components/72_chapter1573redmoondescends'
 import A3_CHAPTER1574ASTRANGEWORLD from '@/components/73_chapter1574astrangeworld'
 import A4_CHAPTER1575PLASTID from '@/components/74_chapter1575plastid'
 import A5_CHAPTER1576EVILTREE from '@/components/75_chapter1576eviltree'
 import A6_CHAPTER1577MISTYSKYCOLLAPSE from '@/components/76_chapter1577mistyskycollapse'
 import A7_CHAPTER1578THEGREATDAO3000CHAOSPALM from '@/components/77_chapter1578thegreatdao3000chaospalm'
 import A8_CHAPTER1579FROSTONSNOW from '@/components/78_chapter1579frostonsnow'
 import A9_CHAPTER1580GRANDDAOSCRIPTURE from '@/components/79_chapter1580granddaoscripture'
 import A0_CHAPTER1581ESCAPEDAY from '@/components/80_chapter1581escapeday'
 import A1_CHAPTER1582RETURN from '@/components/81_chapter1582return'
 import A2_CHAPTER1583HEAVENGULLYMOUNTAINSDEMONREGION from '@/components/82_chapter1583heavengullymountainsdemonregion'
 import A3_CHAPTER1584DEMONREGIONPATTERN from '@/components/83_chapter1584demonregionpattern'
 import A4_CHAPTER1585DEMONEMPEROR from '@/components/84_chapter1585demonemperor'
 import A5_CHAPTER1586YOUAREVERYMUCHLIKEAPERSON from '@/components/85_chapter1586youareverymuchlikeaperson'
 import A6_CHAPTER1587GREATEMPEROR from '@/components/86_chapter1587greatemperor'
 import A7_CHAPTER1588WHATISTHESAINTSCONGRESS from '@/components/87_chapter1588whatisthesaintscongress'
 import A8_CHAPTER1589LASTSHREDOFDIGNITY from '@/components/88_chapter1589lastshredofdignity'
 import A9_CHAPTER1590HOLYFAMILYGATHERING from '@/components/89_chapter1590holyfamilygathering'
 import A0_CHAPTER1591THEGREATPENGRISESWITHTHESAMEWINDFORADAY from '@/components/90_chapter1591thegreatpengriseswiththesamewindforaday'
 import A1_CHAPTER1592QISHANLINGDAZZLINGPEAK from '@/components/91_chapter1592qishanlingdazzlingpeak'
 import A2_CHAPTER1593APPARENTSIMILARITY from '@/components/92_chapter1593apparentsimilarity'
 import A3_CHAPTER1594LOVERIVAL from '@/components/93_chapter1594loverival'
 import A4_CHAPTER1595ALOOFHUMBLE from '@/components/94_chapter1595aloofhumble'
 import A5_CHAPTER1596SAINTREBIRTH from '@/components/95_chapter1596saintrebirth'
 import A6_CHAPTER1597THESACREDFAMILYSASSEMBLYHADOFFICIALLYBEGUN from '@/components/96_chapter1597thesacredfamilysassemblyhadofficiallybegun'
 import A7_CHAPTER1598THECRUELTYOFCOMPETITION from '@/components/97_chapter1598thecrueltyofcompetition'
 import A8_CHAPTER1599HOWFARCANTHOSEEYESSEE from '@/components/98_chapter1599howfarcanthoseeyessee'
 import A9_CHAPTER1600UNSTOPPABLEFORCE from '@/components/99_chapter1600unstoppableforce'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1501phantomdreamtoochaotic",
 			"name" : "0_chapter1501phantomdreamtoochaotic",
 			"component" : A_CHAPTER1501PHANTOMDREAMTOOCHAOTIC
 		},
 		{
 			"path" : "/1_chapter1502danger",
 			"name" : "1_chapter1502danger",
 			"component" : A_CHAPTER1502DANGER
 		},
 		{
 			"path" : "/2_chapter1503maplewingheavenlyvalley",
 			"name" : "2_chapter1503maplewingheavenlyvalley",
 			"component" : A_CHAPTER1503MAPLEWINGHEAVENLYVALLEY
 		},
 		{
 			"path" : "/3_chapter1504weepingabyss",
 			"name" : "3_chapter1504weepingabyss",
 			"component" : A_CHAPTER1504WEEPINGABYSS
 		},
 		{
 			"path" : "/4_chapter1505royalphoenixcang",
 			"name" : "4_chapter1505royalphoenixcang",
 			"component" : A_CHAPTER1505ROYALPHOENIXCANG
 		},
 		{
 			"path" : "/5_chapter1506greatwarwarmth",
 			"name" : "5_chapter1506greatwarwarmth",
 			"component" : A_CHAPTER1506GREATWARWARMTH
 		},
 		{
 			"path" : "/6_chapter1507heavenandearthsealgiantdemonseal",
 			"name" : "6_chapter1507heavenandearthsealgiantdemonseal",
 			"component" : A_CHAPTER1507HEAVENANDEARTHSEALGIANTDEMONSEAL
 		},
 		{
 			"path" : "/7_chapter1508vulnerabletoasingleblow",
 			"name" : "7_chapter1508vulnerabletoasingleblow",
 			"component" : A_CHAPTER1508VULNERABLETOASINGLEBLOW
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js